export const TABS = {
	user: 'user',
	market: 'market',
};
